import { battleLineClasses, classifyBattleLine, extractRoundNumber, highlightCombatText } from "@/lib/battlePresentation";

export const BattleLogFeed = ({ lines = [], shown = lines.length, scrollRef = null, loading = false, dataTestId = "battle-log-feed" }) => {
  return (
    <div ref={scrollRef} className="flex-1 bg-black/60 border border-zinc-800 p-3 sm:p-4 h-[40vh] sm:h-[50vh] overflow-y-auto space-y-2 font-manrope text-xs sm:text-sm" data-testid={dataTestId}>
      {lines.map((line, i) => {
        if (i >= shown) return null;
        const meta = classifyBattleLine(line);
        const round = extractRoundNumber(line);
        const body = line.replace(/^R\d+:\s*/, "").replace(/^Round \d+:\s*/, "");
        return (
          <div
            key={i}
            data-testid={`${dataTestId}-line-${i}`}
            className={`fade-up border-l-2 px-3 py-2 break-words rounded-r-sm ${battleLineClasses(meta.kind)}`}
          >
            <div className="flex flex-wrap items-center gap-2 mb-1">
              {round !== null && <span className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">Round {round}</span>}
              <span className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">{meta.label}</span>
            </div>
            <span dangerouslySetInnerHTML={{ __html: highlightCombatText(body) }} />
          </div>
        );
      })}
      {loading && (
        <div className="flex gap-1 pt-1" aria-label="loading" data-testid={`${dataTestId}-loading`}>
          <span className="w-1.5 h-1.5 rounded-full bg-amber-600 animate-bounce" style={{ animationDelay: "0ms" }} />
          <span className="w-1.5 h-1.5 rounded-full bg-amber-600 animate-bounce" style={{ animationDelay: "150ms" }} />
          <span className="w-1.5 h-1.5 rounded-full bg-amber-600 animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
      )}
    </div>
  );
};